var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpened(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 4.5C10.6627 4.5 11.2986 4.76339 11.7674 5.23223C12.2363 5.70107 12.4997 6.33696 12.4997 7C12.4997 7.66304 12.2363 8.29893 11.7674 8.76777C11.2986 9.23661 10.6627 9.5 9.99967 9.5C9.33663 9.5 8.70075 9.23661 8.23191 8.76777C7.76307 8.29893 7.49967 7.66304 7.49967 7C7.49967 6.33696 7.76307 5.70107 8.23191 5.23223C8.70075 4.76339 9.33663 4.5 9.99967 4.5ZM9.99967 0.75C14.1663 0.75 17.7247 3.34167 19.1663 7C17.7247 10.6583 14.1663 13.25 9.99967 13.25C5.83301 13.25 2.27467 10.6583 0.833008 7C2.27467 3.34167 5.83301 0.75 9.99967 0.75ZM2.64967 7C4.02467 9.8 6.86634 11.5833 9.99967 11.5833C13.133 11.5833 15.9747 9.8 17.3497 7C15.9747 4.2 13.133 2.41667 9.99967 2.41667C6.86634 2.41667 4.02467 4.2 2.64967 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default __webpack_public_path__ + "static/media/eyeOpened.95ff7384490641a7d4551bfed91579b9.svg";
export { ForwardRef as ReactComponent };